// @flow

import React from 'react';

import { ButtonWrapper } from 'client/components/preRegistration/preRegistration';
import CountdownClock from 'client/components/preRegistration/countdownClock';
import { PRE_REG_OEP_COUNTDOWN_CTA } from 'client/constants/amplitudeTracker';

import { Tracking } from 'web-core/src/tracking';

type Props = {
  continueBtn: string,
  continuePath: string,
  ctaBtn: string,
  ctaPath: string,
  header: string,
  isEmptyCart: boolean,
  oepEndDate: string,
  subheader: string,
};

const OepCountdown = (props: Props) => {
  const {
    continuePath,
    continueBtn,
    ctaPath,
    ctaBtn,
    isEmptyCart,
    header,
    oepEndDate,
    subheader,
  } = props;
  const path = isEmptyCart ? ctaPath : continuePath;
  const btnText = isEmptyCart ? ctaBtn : continueBtn;

  const handleRedirect = () => {
    Tracking.track(PRE_REG_OEP_COUNTDOWN_CTA, { path });
    window.location.href = path;
  };
  return (
    <React.Fragment>
      <h1 className="medium">{header}</h1>
      <h3>{subheader}</h3>
      <CountdownClock targetDate={oepEndDate} />
      <ButtonWrapper clickHandler={handleRedirect}>{btnText}</ButtonWrapper>
    </React.Fragment>
  );
};

export default OepCountdown;
